(function () {
  var RETRY_DELAY = 100;
  var MAX_RETRIES = 20;

  function initCarousels() {
    document.querySelectorAll('.lp-protocol-cards__layout').forEach(function (section) {
      var sliderEl = section.querySelector('.lp-protocol-cards__cards');
      if (!sliderEl) return;

      var flkty = new window.Flickity(sliderEl, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: false,
        imagesLoaded: true,
      });

      var dotsContainer = section.querySelector('.lp-protocol-cards__dots');
      if (!dotsContainer) return;

      var dots = dotsContainer.querySelectorAll('.lp-protocol-cards__dot');

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          flkty.select(i);
        });
      });

      flkty.on('change', function (index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('lp-protocol-cards__dot--active', i === index);
        });
      });
    });
  }

  function tryInit(retries) {
    if (typeof window.Flickity !== 'undefined') {
      initCarousels();
    } else if (retries > 0) {
      setTimeout(function () { tryInit(retries - 1); }, RETRY_DELAY);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    tryInit(MAX_RETRIES);
  });
})();
